/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const merchantInfoRouter = {
  path: '/merchantInfo',
  component: Layout,
  hidden: false,
  alwaysShow: true,
  redirect: 'noredirect',
  name: 'merchantInfo',
  meta: {
    title: '商户管理',
    icon: 'merchant',
    roles: ['merchant']
  },
  children: [
    // {
    //   path: 'merchantWithdrawList',
    //   component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawList'], resolve),
    //   name: 'merchantWithdrawList',
    //   meta: { title: 'merchantWithdrawList', noCache: true }
    // },
    {
      path: 'merchantWithdrawModel',
      // component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawModel'], resolve),//原商户提现页面，批量提现
      component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawal'], resolve),//新版商户提现，单个提现页面
      name: 'MerchantWithdrawModel',
      meta: { title: '代收商户提现', noCache: false }
    },
    {
      path: 'merchantWithdrawModelBatch',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawModel'], resolve),//原商户提现页面，批量提现
      // component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawal'], resolve),//新版商户提现，单个提现页面
      name: 'MerchantWithdrawModelBatch',
      meta: { title: '代付商户提现', noCache: false }
    },
    // {
    //   path: 'merchantMaleWithdrawal-291',
    //   component: resolve => require(['@/views/merchant/merchantInfo/merchantMaleWithdrawal'], resolve),
    //   name: 'MerchantMaleWithdrawal',
    //   meta: { title: '对公代付', noCache: false },
    // },
    {
      path: 'merchantWithdrawalRecord',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantWithdrawalRecord'], resolve),
      name: 'MerchantWithdrawalRecord',
      meta: { title: '代付记录', noCache: false },
    },
    {
      path: 'merchantRecharge',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantRecharge'], resolve),
      name: 'MerchantRecharge',
      meta: { title: '网银充值', noCache: false },
    },
    {
      path: 'merchantRechargeU',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantRecharge'], resolve),
      name: 'MerchantRechargeU',
      meta: { title: 'USDT充值', noCache: false },
    },
    {
      path: 'merchantTransferDetail-114',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantTransferDetail'], resolve),
      name: 'MerchantTransferDetail',
      meta: { title: '资金变动', noCache: false }
    },
    // {
    //   path: 'merchantsMember-268',
    //   component: resolve => require(['@/views/merchant/merchantInfo/merchantsMember'], resolve),
    //   name: 'MerchantsMember',
    //   meta: { title: '商户会员', noCache: false }
    // },
    {
      path: 'keyManagement',
      component: resolve => require(['@/views/merchant/merchantInfo/keyManagement'], resolve),
      name: 'KeyManagement',
      meta: { title: '密钥管理', noCache: false }
    },
    {
      path: 'merchantPoundage:list',
      component: resolve => require(['@/views/merchant/merchantInfo/merchantPoundage'], resolve),
      name: 'merchantPoundage',
      meta: { title: '商户费率', noCache: false }
    },
    {
      path: 'robotBind',
      component: resolve => require(['@/views/merchant/merchantInfo/robotBind'], resolve),
      name: 'RobotBind',
      meta: { title: '机器人绑定', noCache: false }
    },
  ]
}

export default merchantInfoRouter



// WEBPACK FOOTER //
// ./src/router/merchant/merchantInfo.js